import type AttendeeResponseCounts from '../schema/AttendeeResponseCountsInterface';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import isAttendeeOrganizer from './isAttendeeOrganizer';

/**
 * Gives the number of attendees who did not respond, who accepted, who are tentative and who declined, excluding the organiser and the resources
 * @param item The item for which attendee response counts are to be generated
 */
export default function getAttendeResponseCounts(item: CalendarEvent): AttendeeResponseCounts {
    var responseCounts: AttendeeResponseCounts = {
        noReponses: 0,
        accepted: 0,
        declined: 0,
        tentative: 0,
    };

    var countResponses = (attendee: AttendeeType) => {
        if (isAttendeeOrganizer(item.Organizer, attendee)) {
            return; // don't include the organizer response
        }
        switch (attendee.ResponseType) {
            case 'Accept':
                responseCounts.accepted++;
                break;
            case 'Tentative':
                responseCounts.tentative++;
                break;
            case 'Decline':
                responseCounts.declined++;
                break;
            default:
                responseCounts.noReponses++;
                break;
        }
    };

    if (item.RequiredAttendees) {
        item.RequiredAttendees.forEach(countResponses);
    }

    if (item.OptionalAttendees) {
        item.OptionalAttendees.forEach(countResponses);
    }

    return responseCounts;
}
